export default __webpack_public_path__ + "static/media/character-bear-idle.850c746c.png";